<template>
  <b-container>
    <h3>{{ $t('Orders.title') }}</h3>
    <b-table
      responsive
      outlined
      striped
      hover
      :items="items"
      :fields="fields"
      :per-page="perPage"
      :current-page="currentPage"
      id="orderTable"
    >
      <template v-slot:cell(details)="row">
        <b-button
          variant="danger"
          size="sm"
          @click="row.toggleDetails"
          class="mr-2"
        >{{ row.detailsShowing ? $t('Orders.hide') : $t('Orders.show') }} {{ $t('Orders.details') }}</b-button>
      </template>

      <template v-slot:cell(payment_type)="data">{{ capitalizeFirstLetter(data.item.payment_type) }}</template>

      <template v-slot:cell(paid)="data">
        <span v-if="data.item.paid === true" style="color: green;">{{ $t('Orders.paidYes') }}</span>
        <span v-if="data.item.paid === false" style="color: red;">{{ $t('Orders.paidNo') }}</span>
      </template>

      <!-- <template v-slot:cell(order_status)="data">
            <b-link href="#" @click="showModal(data.item)">{{ capitalizeFirstLetter(data.item.order_status) }}</b-link>
      </template>-->

      <template v-slot:cell(created)="data">
        <!-- {{new Date(data.item.created).getDay()}} -->
        {{buildDate(data.item.created)}}
      </template>

      <template v-slot:row-details="row">
        <b-card class="text-left">
          <b-row class="mb-2">
            <b-col>
              <b>{{ $t('Orders.orderId') }}:</b>
              {{ row.item.orderConfId }}
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col>
              <b>{{ $t('Orders.customerName') }}:</b>
              {{ row.item.name }}
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col>
              <b>{{ $t('Orders.total') }}:</b>
              {{ row.item.amount.toFixed(2) }} {{ row.item.currency }}
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col>
              <b>{{ $t('Orders.items') }}:</b>
            </b-col>
          </b-row>

          <b-row class="mb-2" v-for="menuitem in row.item.items" :key="menuitem.style">
            <b-col>{{ menuitem.name }}, {{ menuitem.style }}</b-col>
            <b-col>{{ $t('Orders.extras') }}: {{ menuitem.extras }}</b-col>
            <b-col>{{ $t('Orders.quantity') }}: {{ menuitem.quantity }}</b-col>
            <b-col>{{ menuitem.price.toFixed(2) }} {{ menuitem.currency }}</b-col>
          </b-row>
        </b-card>
      </template>
    </b-table>

    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      :per-page="perPage"
      aria-controls="orderTable"
      align="center"
    />

    <!-- <b-row class="mt-3 justify-content-right">
          <b-btn variant="danger" @click="getCSV">CSV</b-btn>
    </b-row>-->
    <b-row class="mt-3 justify-content-center">
      <b-alert :show="error.received" variant="danger" class="text-center" dismissible>{{error.msg}}</b-alert>
    </b-row>

    <!-- UPDATE STATUS MODAL -->
    <!-- <b-modal ref="updateStatusModalRef" hide-footer header-bg-variant="danger" title="Order Status">
        <div class="d-block text-center">
          <b-form-group>
            <b-form-radio-group
              buttons
              button-variant="outline-danger"
              size="lg"
              v-model="orderStatusSelected"
              :options="orderStatusOptions"
            />
          </b-form-group>
        </div>
        <b-btn class="mt-3" cancel @click="hideModal">Cancel</b-btn>
        <b-btn class="mt-3" ok variant="danger" @click="updateOrderStatus">Change</b-btn>
    </b-modal>-->
  </b-container>
</template>

<script>
import OrdersService from '@/services/OrdersService'
export default {
  data () {
    return {
      items: [],
      fields: [
        {
          key: 'tableNumber',
          sortable: false
        },
        {
          key: 'details',
          sortable: false
        },
        {
          key: 'payment_type',
          sortable: true
        },
        {
          key: 'paid',
          sortable: true
        },
        {
          key: 'created',
          sortable: true
        }
      ],
      error: {
        received: false,
        msg: ''
      },
      perPage: 10,
      currentPage: 1

      /* ,
      orderStatusSelected: null,
      orderStatusOptions: [
        { text: 'New', value: 'new' },
        { text: 'Ongoing', value: 'ongoing' },
        { text: 'Completed', value: 'completed' }
      ],
      currentItemId: null */
    }
  },
  mounted () {
    // redirect if user not logged in
    let smartdineLocalStorage = JSON.parse(
      window.localStorage.getItem('smartdine')
    )

    if (!smartdineLocalStorage.token) this.$router.push({ name: 'Login' })
    // else, get orders
    else this.getOrders()
  },
  methods: {
    async getOrders () {
      try {
        const response = await OrdersService.getOrders()
        this.items = response.data.orders
      } catch (error) {
        this.error.received = true
        this.error.msg = error.response.data.error
      }
    },
    /* async updateOrderStatus () {
      const statusUpdate = {
        _id: this.currentItemId,
        order_status: this.orderStatusSelected
      }
      try {
        // update order
        const response = await OrdersService.updateOrderStatus(statusUpdate)
        // get udated orders
        if (response.data.orderStatusUpdated === true) {
          this.getOrders()
        }
      } catch (error) {
        this.error.received = true
        this.error.msg = 'Something went wrong with Order Status update.'
      }
      // close modal
      this.hideModal()
    },
    showModal (item) {
      // set current item
      this.orderStatusSelected = item.order_status
      this.currentItemId = item._id

      // show modal
      this.$refs.updateStatusModalRef.show()
    },
    hideModal () {
      this.$refs.updateStatusModalRef.hide()
    }, */
    getCSV () {
      OrdersService.getCSV()
    },
    capitalizeFirstLetter (word) {
      return word.charAt(0).toUpperCase() + word.slice(1)
    },
    buildDate (date) {
      let d = new Date(date)
      return (
        [
          (d.getHours() < 10 ? '0' : '') + d.getHours(),
          (d.getMinutes() < 10 ? '0' : '') + d.getMinutes()
        ].join(':') +
        ', ' +
        [d.getDate(), d.getMonth() + 1, d.getFullYear()].join('/')
      )
    }
  },
  computed: {
    rows () {
      return this.items.length
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Orders.vue